import { ChangeDetectionStrategy, Component, inject, NgZone, signal } from '@angular/core';
import gsap from "gsap";

@Component({
  selector: 'skyscraper9',
  standalone: false,
  templateUrl: './skyscraper9.component.html',
  styleUrl: './skyscraper9.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Skyscraper9Component {
  private zone = inject(NgZone);
  public finalHeight = signal<number>(350); 
  public height = signal<number>(200);
  public width = signal<number>(400);


  ngAfterViewInit(): void {
    this.animate();
  }

  animate() {
    const obj = { x: this.height() };
    gsap.to(obj, {
      x: this.finalHeight(),
      duration: 1,
      delay: 2,
      ease: "power2.inOut",
      onUpdate: () => {
        this.zone.run(() => {
          this.height.set(obj.x);
        });
      },
    });
  }
}
